import { condition_default } from 'ducks/condition/defaults';
import { indicator_default } from 'ducks/indicator/defaults';
import { trigger_default } from 'ducks/trigger/defaults';

import { EMPTY_ARRAY, EMPTY_FUNCTION } from '../../constants';
import { strategy_default } from '../../ducks/strategy/defaults';

import { IndicatorContextProps, StrategyContextProps, TriggerContextProps } from './types';

export const strategy_context_initial_state: StrategyContextProps = {
  strategy: { ...strategy_default },
  condition: { ...condition_default },
  indicators: EMPTY_ARRAY,
  updateIndicators: EMPTY_FUNCTION,
  updateCondition: EMPTY_FUNCTION,
  setCondition: EMPTY_FUNCTION,
  setStrategy: EMPTY_FUNCTION,
  updateStrategy: EMPTY_FUNCTION,
  updateStrategyTrigger: EMPTY_FUNCTION,
  removeStrategyTrigger: EMPTY_FUNCTION,
  updateStrategyTriggerCondition: EMPTY_FUNCTION,
  removeStrategyTriggerCondition: EMPTY_FUNCTION,
  addStrategyTriggerCondition: EMPTY_FUNCTION,
  replaceStrategyTriggerCondition: EMPTY_FUNCTION,
};

export const trigger_context_initial_state: TriggerContextProps = {
  trigger: { ...trigger_default },
  setTrigger: EMPTY_FUNCTION,
  updateTrigger: EMPTY_FUNCTION,
};

export const indicator_context_initial_state: IndicatorContextProps = {
  indicator: { ...indicator_default },
  indicators: EMPTY_ARRAY,
  setIndicator: EMPTY_FUNCTION,
  updateIndicator: EMPTY_FUNCTION,
  setIndicators: EMPTY_FUNCTION,
  updateIndicators: EMPTY_FUNCTION,
};
